import * as Yup from "yup";

export enum OfficeFormHeader {
  add = "Add Office",
  edit = "Edit Office",
}

export const StatusOptions = ["Active", "Inactive"] as const;

export const OfficeFormSchema = Yup.object({
  status: Yup.string()
    .oneOf([...StatusOptions])
    .defined("Required"),
  name: Yup.string().required("Required"),
  address: Yup.string().required("Required"),
  companies: Yup.array(Yup.string()).min(1).required("Required"),
});

export type OfficeFormType = Yup.TypeOf<typeof OfficeFormSchema>;
